import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext, Children, cloneElement } from 'react';
import Context from '@gisatcz/cross-package-react-context';
import TimelineEventsWrapper from './TimelineEventsWrapper';
import propTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var TimelineContent = function TimelineContent(_ref) {
  var children = _ref.children,
      propsWithoutChildren = _objectWithoutProperties(_ref, _excluded);

  var defaultHoverContext = 'TimeLineContext';
  var HoverContext = Context.getContext(defaultHoverContext);
  var context = useContext(HoverContext);
  var periodLimit = context.periodLimit,
      height = context.height,
      width = context.width,
      dayWidth = context.dayWidth,
      period = context.period,
      mouseX = context.mouseX,
      vertical = context.vertical,
      activeLevel = context.activeLevel;
  var elementWidth = vertical ? height : width;
  var elementHeight = vertical ? width : height;
  var transform = vertical ? "scale(-1,1) translate(-".concat(height, ",0)") : '';
  var childrenWithProps = [];
  Children.forEach(children, function (child) {
    childrenWithProps.push( /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, propsWithoutChildren), {}, {
      period: period,
      periodLimit: periodLimit,
      getX: function getX(dayWidth) {
        return context.getX(dayWidth);
      },
      height: height,
      width: width,
      dayWidth: dayWidth,
      vertical: vertical,
      mouseX: mouseX,
      activeLevel: activeLevel
    })));
  });
  return /*#__PURE__*/_jsx(TimelineEventsWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      className: "ptr-timeline-content",
      style: {
        height: elementHeight
      },
      children: /*#__PURE__*/_jsx("svg", {
        version: '1.1',
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        width: elementWidth,
        height: elementHeight,
        children: /*#__PURE__*/_jsx("g", {
          transform: transform,
          children: childrenWithProps
        })
      })
    })
  });
};

TimelineContent.propTypes = {
  children: propTypes.node
};
export default TimelineContent;